@if (content) {
<!-- close button -->
<div class="w-12 right">
    <i class="icon-close p-a-2"
       (click)="close()"
       aria-hidden="true"></i>
</div>
<div class="p-l-3 p-r-3">
    <!-- added item -->
    <p class="h3 col-1"
       *iCms="'title' of content"></p>
    @for (basketItem of basketItems; track basketItem.id) {
    <basket-view-item class="block m-t-5"
                      [item]="basketItem"
                      [hideQty]="true"
                      [context]="'notice'"></basket-view-item>
    }
</div>
<div class="b-col-w m-t-5 p-r-4 p-l-4 p-t-5 p-b-5 box-shadow-2">
    <!-- bottom buttons -->
    <a buttonStyle
       class="w-12"
       [routerLink]="'/basket'"
       *iCms="'buttonLabel' of content">
    </a>
    <!-- delivery copy -->
    <p class="m-t-2 col-11 p2 center"
       *iCms="'deliveryText' of content; skipEmpty true"></p>
</div>
}